import { render, staticRenderFns } from "./FundaBNPLJangsa3Check.vue?vue&type=template&id=87481840&scoped=true&"
import script from "./FundaBNPLJangsa3Check.vue?vue&type=script&lang=js&"
export * from "./FundaBNPLJangsa3Check.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPLJangsa3Check.vue?vue&type=style&index=0&id=87481840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87481840",
  null
  
)

export default component.exports